<template>
<div>
  <div class="animation-container">
    <div class="circle"></div>
    <svg class="lock"
         viewBox="0 0 336 421"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
        class="down"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.4 155C14.5593 155 10.6389 155 7.64413 156.526C5.00987 157.868 2.86814 160.01 1.52591 162.644C7.15256e-07 165.639 0 169.559 0 177.4V398.6C0 406.441 7.15256e-07 410.361 1.52591 413.356C2.86814 415.99 5.00987 418.132 7.64413 419.474C10.6389 421 14.5593 421 22.4 421H313.6C321.441 421 325.361 421 328.356 419.474C330.99 418.132 333.132 415.99 334.474 413.356C336 410.361 336 406.441 336 398.6V177.4C336 169.559 336 165.639 334.474 162.644C333.132 160.01 330.99 157.868 328.356 156.526C325.361 155 321.441 155 313.6 155L22.4 155ZM206.5 267.7C206.5 281.608 199.126 293.793 188.074 300.559L191.112 333.982C191.857 342.181 185.402 349.25 177.169 349.25H158.83C150.598 349.25 144.143 342.181 144.888 333.982L147.926 300.559C136.874 293.793 129.5 281.608 129.5 267.7C129.5 246.437 146.737 229.2 168 229.2C189.263 229.2 206.5 246.437 206.5 267.7Z"
        fill="#6D7782"
      />
      <path
        class="up"
        d="M167.5 0C97.0837 0 50 56.5752 50 126.364V225H94.8352V126.364C94.8352 81.1164 121.845 44.4358 167.5 44.4358C213.155 44.4358 240.165 81.1164 240.165 126.364V154.966H285V126.364C285 56.5752 237.916 0 167.5 0Z"
        fill="#6D7782"
      />
    </svg>
  </div>
  <div v-if="$store.state.isActivated">
    <div class="logo-top-block">
      <img class="logo" src="/img/icon.svg" alt="" style="width:75px;height:75px;" />
      <div class="heading">B-Pay</div>
      <div class="heading2">Сканируй и покупай</div>
      <div class="stars"><img src="/img/stars.svg" alt="" style="width:124px;height:20px;" /></div>
      <div class="icons">
        <img class="ico-ios" src="/img/ico-ios.svg" alt="" />
        <img class="ico-android" src="/img/ico-android.svg" alt="" />
      </div>
    </div>
    <div class="index-new">
      <div class="scan-marker"></div>
      <div class="qr-bg">
        <qrcode :value="qr_code_url" :options="{ width: 210, margin: 1}" style="margin-left:14px;margin-top:14px;"></qrcode>
      </div>
      <div class="btn-caption">Для покупки по карте нажмите кнопку</div>
      <img class="buy-btn" src="/img/btn.svg" alt="" />
      <a href='#' @click.prevent="login" class="btn">начать покупки</a>
    </div>
  </div>
  <div v-else>
    <div class="container">
      <div class="content-block start-page" style="margin-top: 200px;">
        <div class="pay-block">
          <span class="fs30 medium" style="color:#fff;">Введите ключ активации</span>
          <input type="text"
                 v-model="key"
                 placeholder=""
                 style="height: 60px;width: 100%;border: 1px solid black;margin: 10px 0 10px 0;text-align: center;font-size: 38px;border-color:#fff;"
          />
          <a href="#" @click.prevent="activateTerminal" class="btn">Привязать терминал</a>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Index',
  data() {
    return {
      key: '',
      qr_code_url: '',
      qr_code_url_app: 'http://app.briskly.online/',
      devices_channel_key: '',
      have_qr: false,
    };
  },
  created() {
    this.$store.state.timeSpent = 0;
  },
  mounted() {
    this.animation();
    this.init();
  },
  methods: {
    animation() {
      let loading = false;

      const container = document.querySelector('.animation-container');
      const lock = document.querySelector('.lock');
      const circle = document.querySelector('.circle');
      const up = lock.querySelector('.up');
      const down = lock.querySelector('.down');

      container.addEventListener('animationend', animationEndHandler);

      start();

      function animationEndHandler({ animationName }) {
        if (animationName.indexOf('lock-up') !== -1) {
          loading = false;
          setTimeout(function() {
            container.style.zIndex = '-999';
          }, 1000);
        }
      }

      function start() {
        if (loading) return;
        loading = true;

        container.style.zIndex = '999';
        lock.style.animationPlayState = 'running';
        container.style.animationPlayState = 'running';

        const after = () => {
          lock.removeEventListener('animationend', after);
          up.style.animationPlayState = 'running';
          down.style.animationPlayState = 'running';
          circle.style.animationPlayState = 'running';
        };

        lock.addEventListener('animationend', after);
      }
    },
    activateTerminal() {
      let elem = this;
      if (this.key) {
        this.$api
          .post('/activate/', {
            code: this.key,
          })
          .then(response => {
            if (response.data.key) {
              localStorage.setItem('devices_channel_key', response.data.key);
              localStorage.setItem('qr_code_url', response.data.qr_code_url);
              this.init();
            } else {
              this.$alert('Терминал уже привязан');
            }
          });
      }
    },
    login() {
      this.$router.push('/login?action=check&terminal_key=' + localStorage.getItem('devices_channel_key'));
    },
    init() {
      if (localStorage.getItem('devices_channel_key')) {
        this.$store.state.isActivated = true;
        this.$api
          .get('/unregister-customer/', { store_terminal_key: localStorage.getItem('devices_channel_key') })
          .then(response => {
            if (response.status !== 200) {
              this.$store.state.isActivated = false;
              localStorage.removeItem('devices_channel_key');
            } else {
              if (localStorage.getItem('devices_channel_key')) {
                this.$store.state.isActivated = true;
              }
              if (localStorage.getItem('access_token')) {
                this.$store.state.isAuthorized = true;
              }

              this.qr_code_url = localStorage.getItem('qr_code_url');
              this.have_qr = true;
              this.devices_channel_key = localStorage.getItem('devices_channel_key');

              if (this.devices_channel_key) {
                this.$root.$emit('settingSocket', this.devices_channel_key);
              }

              if (this.$store.state.isActivated) {
                this.$router.push('/?action=auth&terminal_key=' + localStorage.getItem('devices_channel_key'));
              }
            }
          });
      }
    },
  },
};
</script>

<style scoped>
@keyframes lock-circle {
  100% {
    width: 0px;
    height: 0px;
  }
}

@keyframes lock-up {
  100% {
    transform: scale(0.5) translateY(0px);
  }
}

@keyframes lock-down {
  100% {
    transform: scale(0.5) translateY(0px);
  }
}

@keyframes lock-lock {
  100% {
    transform: scale(1);
  }
}

@keyframes lock-container {
  100% {
    opacity: 1;
  }
}

.animation-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #33393f;
  animation: lock-container 0.5s ease 1 alternate;
  animation-fill-mode: forwards;
  animation-play-state: paused;
  animation-delay: 0.3s;
  opacity: 1;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10000;
}

.lock {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
  transform: scale(0.2);
  animation: lock-lock 0.5s 1 alternate ease;
  animation-fill-mode: forwards;
  animation-play-state: paused;
}

.up {
  animation: lock-up cubic-bezier(0.51, 0.75, 1, 0.42) 0.5s alternate 1;
  animation-fill-mode: forwards;
  transform: scale(0.5) translateY(-34px);
  transform-origin: center;
  animation-play-state: paused;
  animation-delay: 0.3s;
}

.down {
  transform: scale(0.5) translateY(34px);
  animation: lock-down cubic-bezier(0.51, 0.75, 1, 0.42) 0.5s alternate 1;
  animation-fill-mode: forwards;
  transform-origin: center;
  animation-play-state: paused;
  animation-delay: 0.3s;
}

.circle {
  position: absolute;
  z-index: 1;
  width: 1500px;
  height: 1500px;
  border-radius: 50%;
  background-color: #33393f;
  animation: lock-circle cubic-bezier(0.51, 0.75, 1, 0.42) 0.5s alternate 1;
  animation-fill-mode: forwards;
  transform-origin: center;
  animation-play-state: paused;
  animation-delay: 0.3s;
}

.start-page .white-bg-block.qr-code-block.el1:before {
  content: '1';
}
.start-page .white-bg-block.qr-code-block.el2:before {
  content: '2';
}
</style>
